module.exports = __webpack_public_path__ + "static/img/logo-test-new.34ccaef0.png";